.details-pane{min-height:20em}table tbody th:first-child{min-width:5em}
/*# sourceMappingURL=mo-results-table.component-ETP7M6AA.css.map */
